import type { SVGProps } from '@/types/common.types';

const SubscriptionStartSVG = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="26"
      viewBox="0 0 54 26"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_27_129)">
        <mask id="mask0_27_129" maskUnits="userSpaceOnUse" x="0" y="0" width="54" height="26">
          <path d="M53.7805 0H0V26H53.7805V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_27_129)">
          <path
            d="M4.91492 0C1.56383 0 0 1.87602 0 4.80092V8.19481C0 11.2306 0.54992 12.5267 2.76679 13.8997L4.47669 14.9485C5.86009 15.7757 6.04053 16.3896 6.04053 18.1633V21.1565C6.04053 22.0262 5.63668 22.5635 4.87195 22.5635C4.10722 22.5635 3.70337 22.0604 3.70337 21.1565V16.4579H0V21.1906C0 24.1496 1.52946 25.9915 4.83758 25.9915C8.25739 25.9915 9.82122 24.0387 9.82122 21.1906V17.5067C9.82122 14.6927 9.0909 13.243 6.98569 11.9127L5.2758 10.8298C4.07284 10.0708 3.7807 9.53362 3.7807 7.58082V4.83503C3.7807 3.96523 4.18455 3.42801 4.90632 3.42801C5.67105 3.42801 6.10927 3.97376 6.10927 4.83503V9.49098H9.82122V4.80092C9.82122 1.91014 8.25739 0 4.91492 0Z"
            fill="#FF2800"
          />
          <path
            d="M10.9898 3.97395H13.6105V25.6421H17.3912V3.97395H20.0119V0.358337H10.9898V3.97395Z"
            fill="#FF2800"
          />
          <path
            d="M44.7584 0.358337V3.97395H47.3791V25.6421H51.1597V3.97395H53.7804V0.358337H44.7584Z"
            fill="#FF2800"
          />
          <path
            d="M22.3405 0.358337L20.2267 25.6335H23.9731L24.4887 18.8798H27.2383L27.7538 25.6335H31.5775L29.4723 0.358337H22.3405ZM24.755 15.4518L25.6486 3.78635H26.0954L26.9891 15.4518H24.755Z"
            fill="#FF2800"
          />
          <path
            d="M43.375 23.7234V17.1488C43.375 15.051 42.5758 13.8998 40.6426 13.499V13.0642C42.5673 12.7742 43.5554 11.3672 43.5554 9.09039V4.80111C43.5554 2.02118 41.8799 0.358337 38.6405 0.358337H33.5108V25.6335H37.2915V15.0595H39.5857V23.7234C39.5857 25.1645 40.2043 25.6335 40.2043 25.6335H43.985C43.9936 25.6421 43.375 25.173 43.375 23.7234ZM39.7747 9.27798C39.7747 11.0858 39.3709 11.623 38.1336 11.623H37.3V3.79487H38.2796C39.4482 3.79487 39.7747 4.26388 39.7747 6.13991V9.27798Z"
            fill="#FF2800"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_27_129">
          <rect width="54" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SubscriptionStartSVG;
